import styled from "styled-components";

export const Input = styled.input(
  () => `
    -webkit-appearance: none; 
    appearance: none;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    outline: 0;
    border: 0;
    margin: 0;
    width: 100%;
    color: var(--color-black);
    background-color: transparent;
    cursor: pointer;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      width: 100%;
      height: 0.2rem;
      background-color: var(--color-orange);
    }

    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      appearance: none;
      width: 0.5rem;
      height: 1rem;
      background-color: var(--color-orange);
    }
      
    &::-moz-range-thumb {
      width: 0.5rem;
      height: 1rem;
      background-color: var(--color-orange);
    }
  `
);
